import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import React from 'react';

import { useImageUrl } from '../../hooks/useImage';

interface ImageObject {
    url: string;
    size?: {
        width: number;
        height: number;
    };
}

interface PageMetaProps {
    title: string;
    url?: string;
    description?: string | null;
    image?: string | ImageObject | null;
    isHome?: boolean;
    canonical?: boolean;
    noIndex?: boolean;
}

function PageMeta({
    title = null,
    description = null,
    image = null,
    url = null,
    isHome = false,
    canonical = false,
    noIndex = false,
}: PageMetaProps) {
    return (
        <>
            <title>{title}</title>
            {!isEmpty(description) ? <meta name="description" content={description!} /> : null}
            <meta property="og:title" content={title} />
            {!isEmpty(image) && !isObject(image) ? (
                <meta property="og:image" content={image as string} />
            ) : null}
            {isObject(image) && !isEmpty((image as ImageObject).url || null) ? (
                <meta property="og:image" content={(image as ImageObject).url} />
            ) : null}
            {isObject(image) && !isEmpty((image as ImageObject)?.size || null) ? (
                <meta
                    property="og:image:width"
                    content={String((image as ImageObject).size!.width)}
                />
            ) : null}
            {isObject(image) && !isEmpty((image as ImageObject)?.size || null) ? (
                <meta
                    property="og:image:height"
                    content={String((image as ImageObject).size!.height)}
                />
            ) : null}
            <meta property="og:type" content="website" />
            {!isEmpty(description) ? (
                <meta property="og:description" content={description!} />
            ) : null}
            <meta property="og:url" content={url} />
            {canonical ? <link rel="canonical" href={url} /> : null}
            {noIndex ? <meta name="robots" content="noindex" /> : null}
        </>
    );
}

export default PageMeta;
